/**
 * Created Jie Gao on 2020-07-14.
 */

import {
    ISymbolStateConfig,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TweenLite} from "gsap";
import {WinterHoardGameConfig} from "../WinterHoardGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {WinterHoardReelSymbol} from "./WinterHoardReelSymbol";

export class WinterHoardReelSymbolScatter extends WinterHoardReelSymbol {

    private _scatterRays: PIXI.spine.Spine;

    constructor(symName: string, reelId: number, state?: ISymbolStateConfig) {
        super(symName, reelId, state);
    }

    protected initAnimations(reinit:boolean = false): void {
        if(reinit){
            return;
        }
        this._scatterRays = new PIXI.spine.Spine(GameResources.getSpineAsset("scatterRays"));
        this._scatterRays.renderable = false;
        this.addChild(this._scatterRays);
    }

    protected reset(remove:boolean):void {
        super.reset(remove);

        if(this._scatterRays) {
            this.removeChild(this._scatterRays);
        }
    }

    protected addNewStateAnimation(timeline: TimelineLite, newState: SymbolStateTransition, stateAnimation: TimelineSprite, delay: number): void {
        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);
        this._scatterRays.renderable = false;
        const state = this._scatterRays.state;
        const winTl: TimelineLite = new TimelineLite();
        if(newState.state.keyword === WinterHoardGameConfig.instance.SYMBOL_STATES.normal.keyword) {
            winTl.add([
                ()=>{
                    this._scatterRays.renderable = true;
                    state.setAnimation(0, "s_landing_glow", false);
                }
            ]);
            winTl.add(()=>{this._scatterRays.renderable = false;}, 0.67);
            timeline.add(winTl, delay);
        }else if (newState.state.keyword === WinterHoardGameConfig.instance.SYMBOL_STATES.trigger.keyword) {
            winTl.add([
                ()=>{
                    this._scatterRays.renderable = true;
                    state.setAnimation(0, "s_trigger_rays", false);
                }]);
            winTl.add(()=>{this._scatterRays.renderable = false;}, 0.67);
            timeline.add(winTl, delay);
        }else if (newState.state.keyword === WinterHoardGameConfig.instance.SYMBOL_STATES.plus.keyword) {
            timeline.add(()=>{
                this._scatterRays.renderable = true;
                state.setAnimation(0, "s_anticipation_glow", true);
            }, delay);
        }else if(newState.state.keyword === WinterHoardGameConfig.instance.SYMBOL_STATES.noWin.keyword) {
            timeline.add(()=>{this._scatterRays.renderable = false;}, delay);
        }
    }
}